import { useEffect, useState } from "react";
import { api } from "./api";

export function useQuote(items) {
  const key = JSON.stringify(items.map((i) => [i.product_id, i.qty]));
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const pairs = JSON.parse(key);
    if (!pairs.length) {
      setQuote(null);
      return undefined;
    }
    let alive = true;
    setLoading(true);
    api
      .post("/cart/quote", { items: pairs.map(([product_id, qty]) => ({ product_id, qty })) })
      .then((r) => alive && setQuote(r.data))
      .catch(() => alive && setQuote(null))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [key]);

  return { quote, loading };
}
